<template>
  <div id="useHelp">
    <!--导航-->
    <topHead style="float: right;position:fixed;z-index: 999;background-color: white;" ref="topHead"></topHead>
    <div style="height: 80px;width: 100%"></div>
    <!--使用帮助-->
    <div class="use-contain">
      <div class="main">
        <el-row class="tac">
          <el-col :span="5" class="menu-bar">
            <ul>
              <li @click="show = !show"  :class="{'li-active': ((showData == 1||showData == 2)&& show==false)}">
                <p>安装快点共享打印</p>
                <el-icon v-if="show" class="el-icon-arrow-up "></el-icon>
                <el-icon v-if="!show" class="el-icon-arrow-down"></el-icon>
              </li>
              <li v-if="show" @click="showData = 1" :class="{'li-active': showData == 1}"><span>下载快点APP并注册账户</span></li>
              <li v-if="show" @click="showData = 2" :class="{'li-active': showData == 2}"><span>下载安装快点Win客户端</span></li>
            </ul>
            <ul>
              <li  @click="showAdd = !showAdd" :class="{'li-active': ((showData == 4||showData == 5)&& showAdd==false)}">
                <p>使用快点共享打印</p>
                <el-icon class="el-icon-arrow-up"></el-icon>
                <el-icon class="el-icon-arrow-down block-none"></el-icon>
              </li>
              <li v-if="showAdd" @click="showData = 4" :class="{'li-active': showData == 4}"><span>手机APP直接打印</span></li>
              <li v-if="showAdd" @click="showData = 5" :class="{'li-active': showData == 5}"><span>Win客户端打印</span></li>
              <li v-if="showAdd" @click="showData = 6" :class="{'li-active': showData == 6}"><span>隐私协议</span></li>
            </ul>
          </el-col>
          <el-col :span="18" :offset="1" class="menu-content">
            <article class="menu-text" :class="{'block-none': !(showData == 1)}">
             <!-- <h3>注册规则</h3>-->
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以在快点官网首页，下载“快点共享打印”APP至您的手机。也可以在您手机自带的应用商店搜索“快点共享打印”并安装。</p>
              <p>安装APP后，依照软件提示进行账户注册，这样您就拥有了一个快点账号啦。<span class="watchvideo" @click="windowOpen('https://music.163.com/#/mv?id=5342215')"> &lt; 查看视频演示 &gt;</span></p>

              <!--<p>2） 用户在选择其看准网用户名时应遵守国家法律法规，不得包含违法、涉嫌侵犯他人权利或干扰网站运营秩序等相关信息。</p>
              <h3>如何使用第三方登录？</h3>
              <p>1） 第三方登录是指用其他社交平台帐号登录看准网，目前支持新浪微博平台和人人平台，您可在登录页点击相应的按钮通过第三方登录看准网，如果是第一次登录需要授权，看准网承诺不会泄露您的任何私人信息。</p>
              <p>2） 使用第三方入口登录的用户，下次登录看准仍需要点击第三方入口的按钮，不可通过输入邮箱密码正常登录看准。您也可在个人中心中设置看准网的账户及密码，设置成功后下次即可输入设置的邮箱和密码正常登录看准网。</p>
              <h3>忘记密码怎么找回？</h3>
              <p>1） 在登录页面点击“忘记密码”，进入找回密码页。</p>
              <p>2） 在找回密码页输入您注册时填写的邮箱，点击确认后系统会发送给您一封重置密码的邮件。</p>
              <p>3） 打开您的邮箱，按照邮件的提示内容及步骤重置密码。</p>
              <h3>用户发布内容规则？</h3>
              <p> 1）为了保护您的隐私，您在看准网发布的点评、工资、面经将以匿名的形式展现。</p>-->
            </article>
            <article class="menu-text" :class="{'block-none': !(showData == 2)}">
             <!-- <h3>公司点评、评论规则</h3>-->
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安装快点APP后，您就可以打印快点文库中的资料（或您的好友分享给您的资料）。如果您需要打印您个人电脑上的资料，请安装快点Windows客户端。</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以在快点官网首页，下载“快点win客户端”。客户端分为完整版和极简版。<span class="watchvideo" @click="windowOpen('https://music.163.com/#/mv?id=5342215')"><span class="watchvideo" @click="windowOpen('https://music.163.com/#/mv?id=5342215')">&lt; 查看视频演示 &gt;</span></span></p>

              <!--<p>2） 禁止灌水重复点评点评内容相似、反复发布，缺少实质体验的点评等。</p>
              <p>3） 禁止非亲身/无主体体验点评。非本人在该公司就职过而进行体验的不真实点评。出于明显商业利益的商家炒作性质点评，出于商业或个人利益的广告性质点评。</p>
              <p>4） 禁止含不当语言点评点评中含有辱骂、侮辱或人身攻击等不当语言。</p>
              <p>5） 禁止违法违规点评存在违反相关法律、法规内容的点评。</p>
              <h3>图片发布规则</h3>
              <p>1） 图片不能带有其它网站水印，图片上不能带有任何网站链接。</p>
              <p>2） 图片清晰可见，无任何PS处理痕迹。</p>
              <p>3） 所有上传的图片按照规定类型、格式、大小正确。</p>
              <p>4） 头像不能使用卡通、合照等一系列不符合个人真实的图片。</p>
              <p>5） 禁止上传色情暴力或包含广告内容的图片。</p>-->
            </article>
            <!--<article class="menu-text" :class="{'block-none': !(showData == 3)}">
              <h3>关于信息审核</h3>
              <p>1） 为什么要审核发布的信息</p>
              <p>审核发布信息，是为了确保每一条信息的真实性。虚假的信息是严格禁止的，为了让看准网的环境健康的发展，请您务必填写真实的信息。</p>
              <p>2）审核结果</p>
              <p>审核通过的信息，在看准网相应的页面可以正常且匿名显示。</p>
              <p>审核未通过的信息，只在看准网个人中心-我发布的内容中显示，您可以选择在个人中心不再显示该条信息。</p>
            </article>-->
            <article class="menu-text" :class="{'block-none': !(showData == 4)}">
             <!-- <h3>注册规则</h3>-->
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以单独使用手机APP进行快点文库中资料（或您的好友分享给您的资料）的打印。点击对应文档后面的打印按钮，该文档就进入“待打印”列表。设置好打印方式，寻找到附近的快点共享打印机，扫码连接后，打印机就会给您打印出来啦。<span class="watchvideo" @click="windowOpen('https://music.163.com/#/mv?id=5342215')">&lt; 查看视频演示 &gt;</span></p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;找到需要打印的文档》点击打印》在“待打印”列表设置打印方式》扫码连接快点共享打印机》确认打印。</p>

              <!--<p>2） 用户在选择其看准网用户名时应遵守国家法律法规，不得包含违法、涉嫌侵犯他人权利或干扰网站运营秩序等相关信息。</p>
              <h3>如何使用第三方登录？</h3>
              <p>1） 第三方登录是指用其他社交平台帐号登录看准网，目前支持新浪微博平台和人人平台，您可在登录页点击相应的按钮通过第三方登录看准网，如果是第一次登录需要授权，看准网承诺不会泄露您的任何私人信息。</p>
              <p>2） 使用第三方入口登录的用户，下次登录看准仍需要点击第三方入口的按钮，不可通过输入邮箱密码正常登录看准。您也可在个人中心中设置看准网的账户及密码，设置成功后下次即可输入设置的邮箱和密码正常登录看准网。</p>
              <h3>忘记密码怎么找回？</h3>
              <p>1） 在登录页面点击“忘记密码”，进入找回密码页。</p>
              <p>2） 在找回密码页输入您注册时填写的邮箱，点击确认后系统会发送给您一封重置密码的邮件。</p>
              <p>3） 打开您的邮箱，按照邮件的提示内容及步骤重置密码。</p>
              <h3>用户发布内容规则？</h3>
              <p> 1）为了保护您的隐私，您在看准网发布的点评、工资、面经将以匿名的形式展现。</p>-->
            </article>
            <article class="menu-text" :class="{'block-none': !(showData == 5)}">
              <!--<h3>关于信息审核</h3>-->
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以安装“快点win客户端”，来打印您个人电脑上的资料。安装了“快点win客户端”后，就相当于您的电脑已经配备了一台看不见的打印机。您可以在电脑上任何可以打印的地方（word、ppt、excel等等）点击打印按钮，只要您选择“kd clould print”这台打印机，您的手机APP上就出现了“待打印”的文档。按照APP的打印方式就可以将该文档打印出来哦。<span class="watchvideo" @click="windowOpen('https://music.163.com/#/mv?id=5342215')">&lt; 查看视频演示 &gt;</span><p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在电脑上点击打印》在APP“待打印”列表设置打印方式》扫码连接快点共享打印机》确认打印。</p>

              <!--<p>审核发布信息，是为了确保每一条信息的真实性。虚假的信息是严格禁止的，为了让看准网的环境健康的发展，请您务必填写真实的信息。</p>
              <p>2）审核结果</p>
              <p>审核通过的信息，在看准网相应的页面可以正常且匿名显示。/p>
              <p>审核未通过的信息，只在看准网个人中心-我发布的内容中显示，您可以选择在个人中心不再显示该条信息。</p>-->
            </article>
            <article class="menu-text" :class="{'block-none': !(showData == 6)}">
              <!--<h3>关于信息审核</h3>-->
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;快点在线科技服务有限公司尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，快点在线科技服务有限公司会按照本隐私权政策的规定使用和披露您的个人信息。
                但快点在线科技服务有限公司将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，快点在线科技服务有限公司不会将这些信息对外披露或向第三方提供。
                快点在线科技服务有限公司会不时更新本隐私权政策。您在同意快点在线科技服务有限公司服务使用协议之时，即视为您已经同意本隐私权政策全部内容。
                本隐私权政策属于快点在线科技服务有限公司服务使用协议不可分割的一部分。</p>
              <p>1.适用范围</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a) 在您注册快点在线科技服务有限公司帐号时，您根据快点在线科技服务有限公司要求提供的个人注册信息；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b) 在您使用快点在线科技服务有限公司网络服务，或访问快点在线科技服务有限公司平台网页时，快点在线科技服务有限公司自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c) 快点在线科技服务有限公司通过合法途径从商业伙伴处取得的用户个人数据。</p>

              <p> 您了解并同意，以下信息不适用本隐私权政策：</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a) 您在使用快点在线科技服务有限公司平台提供的搜索服务时输入的关键字信息；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b) 快点在线科技服务有限公司收集到的您在快点在线科技服务有限公司发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c) 违反法律规定或违反快点在线科技服务有限公司规则行为及快点在线科技服务有限公司已对您采取的措施。</p>

              <p> 2.信息使用</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a) 快点在线科技服务有限公司不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和快点在线科技服务有限公司（含快点在线科技服务有限公司关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b) 快点在线科技服务有限公司亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何快点在线科技服务有限公司平台用户如从事上述活动，一经发现，快点在线科技服务有限公司有权立即终止与该用户的服务协议。</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c) 为服务用户的目的，快点在线科技服务有限公司可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与快点在线科技服务有限公司合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。</p>

              <p>3.信息披露</p>
              <p>在如下情况下，快点在线科技服务有限公司将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a) 经您事先同意，向第三方披露；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;d) 如您出现违反中国有关法律、法规或者快点在线科技服务有限公司服务协议或相关规则的情况，需要向第三方披露；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;f) 在快点在线科技服务有限公司平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，快点在线科技服务有限公司有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。

              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;g) 其它快点在线科技服务有限公司根据法律、法规或者网站政策认为合适的披露。</p>

            </article>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'

export default {
  data () {
    return {
      show: true,
      showAdd: true,
      showData: 1
    }
  },
  created () {
    Api.changeClass = 1
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    // 打开外链
    windowOpen (url) {
      window.open(url)
    }
  }
}
</script>

<style>
  .watchvideo{
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
  .watchvideo span{
  }
  .nav-content {
    width: 100%;
    height: 80px;
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }
  .main {
    width: 1200px;
  }
  .use-contain{
    width: 100%;
    background-color: #f5f5f5;
    padding: 30px 0px;
  }
  .menu-bar{
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 3px 5px 10px -2px rgba(0,0,0,0.09),
    -3px -5px 10px -2px rgba(0,0,0,0.09);
    padding: 20px 0px;
  }
  .menu-bar li{
    padding: 0px 40px;
    text-align: left;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
  }
  .menu-bar li:hover{
    background-color: #f62828;
    color: #fff;
  }
  .menu-bar .li-active{
    background-color: #f62828;
    color: #fff;
  }
  .menu-bar li p{
    font-size: 18px;
    display: inline-block;
  }
  .menu-bar li i{
    float: right;
    line-height: 50px;
  }
  .menu-bar li span{
    padding-left: 15px;
    font-size: 14px;
  }
  .menu-content{
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 3px 5px 10px -2px rgba(0,0,0,0.09),
    -3px -5px 10px -2px rgba(0,0,0,0.09);
    min-height: 650px;
    padding: 30px;
  }
  .menu-text{
    text-align: left;
  }
  .menu-text h3{
    font-size: 16px;
    color: #333;
    line-height: 40px;
  }
  .menu-text p{
    font-size: 14px;
    color: #444;
    line-height: 30px;
  }
  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
  }
  .block-none{
    display: none;
  }
  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UseHelp.vue